import { createContext } from 'react';

import type { XYChartVisibleAxesScales } from '../../types/xy-chart-internals.js';

export const XYChartVisibleAxesScalesContext = createContext<
  XYChartVisibleAxesScales | undefined
>(undefined);
